// #region Local Imports
import { ActionConsts } from "@Definitions";
// #endregion Local Imports

// #region Interface Imports
import { IAction, IHomePage } from "@Interfaces";
// #endregion Interface Imports

const INITIAL_STATE: IHomePage.IStateProps = {
  cart: null,
  shippingCharge: null,
  loader: false,
  isCartEmpty: false,
  estimateDeliveryDate: null,
  headerNotification: [],
};

type IMapPayload = IHomePage.Actions.IMapPayload;

export const CartReducer = (
  state = INITIAL_STATE,
  action: IAction<IMapPayload>
) => {
  switch (action.type) {
    case ActionConsts.Cart.AddToCart:
      return {
        ...state,
        ...action.payload,
      };

    case ActionConsts.Cart.ClearCart:
      return {
        ...state,
        cart: null,
        shippingCharge: null,
      };
    case ActionConsts.Cart.setShippingCharge:
      return {
        ...state,
        shippingCharge: action.payload,
      };
    case ActionConsts.Cart.setEstimateDeliveyDate:
      return {
        ...state,
        estimateDeliveryDate: action.payload,
      };
    case ActionConsts.Cart.showLoader:
      return {
        ...state,
        loader: true,
      };

    case ActionConsts.Cart.hideLoader:
      return {
        ...state,
        loader: false,
      };
    case ActionConsts.Cart.ShowCartLoader:
      return {
        ...state,
        isCartEmpty: true,
      };
    case ActionConsts.Cart.setHeaderNotification:
      return {
        ...state,
        headerNotification: action.payload,
      };
    case ActionConsts.Cart.HideCartLoader:
      return {
        ...state,
        isCartEmpty: false,
      };
    default:
      return state;
  }
};
